import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const TitleWrapper = styled.div`
  text-align: center;
  > span {
    font-family: ${(props) => props.theme.fontFamily};
    color: ${(props) => props.theme.fontColor};
  }
  padding: 16px;
`;

const Title = () => (
  <TitleWrapper>
    <span
      style={{
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
      }}
    >
      <FormattedMessage defaultMessage="Sign in to your account" />
    </span>
  </TitleWrapper>
);

export default Title;
